module.exports = __webpack_public_path__ + "img/upload-image.f4886934.svg";